import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import * as actions from '../orderSettingActions';
import {
  setDeliveryAddressesFormIsVisible,
  setGuestDeliveryAddressFormInitialValues,
} from '../../DeliveryAddresses/deliveryAddressesActions';
import {
  setDropOffLocationFormIsVisible,
  getFirstDropOffSelection,
  setIsEditDropOffLocation,
  deleteDropOffLocation,
  restoreSelectedLocation,
} from '../../DropOff/dropOffLocationActions';
import {
  validateCart,
  updateCartWithUnavailbleProducts,
  emptyCart,
  validateCartForLocation,
  resetCartErrorMessages,
  validateGlobalCart,
} from '../../Cart/cartActions';
import { resetGuestSession } from '../../Auth/authActions';
import { PICKUP, DELIVERY, DROPOFF } from '../orderSettingTypes';
import Dialog from '../../../components/Dialog/Dialog';
import { withStyles } from '@material-ui/core/styles';
import MarketplaceOrderSettingModal from './MarketplaceOrderSettingModal';
import OrderingClosedContainer from '../OrderingClosed/OrderingClosedContainer';
import appConfigFile from '../../../../app-config';
import { connectSearchBox } from 'react-instantsearch-dom';
import { getMenu } from '../../OnAppLoad/Menu/menuActions';

const styles = () => ({
  scrollPaper: {},
  paper: {
    margin: 0,
    maxHeight: '90%',
    overflowY: 'visible',
    maxWidth: '100%',
  },
});

const MarketplaceOrderSettingModalContainer = ({
  classes,
  validateGlobalCart,
  orderSettingReducer,
  updateInterOrderType,
  locations,
  updateInterPickUpDetails,
  deliveryAddressesList,
  updateInterDeliveryDetails,
  updateInterSelectedDateTime,
  getTimeIntervalsDate,
  updateOrderSettingModalIsVisible,
  confirmPickUpDetails,
  resetInterSelectedDateTime,
  resetDateTimes,
  requestingGetLocations,
  confirmMarketplaceDeliverySelection,
  setDeliveryAddressesFormIsVisible,
  validateCart,
  resetIsTimeNoLongerValid,
  currentLocation,
  isAuthenticated,
  hideToolTip,
  nearestLocation,
  orderHistory,
  cartReducer,
  updateCartWithUnavailbleProducts,
  emptyCart,
  orderingClosedInAllLocations,
  getBusinessSpecialHours,
  setChildLocation,
  setDropOffLocationFormIsVisible,
  updateInterDropOffDetails,
  confirmDropOffDetails,
  getFirstDropOffSelection,
  dropOffLocationReducer,
  setIsEditDropOffLocation,
  deleteDropOffLocation,
  restoreSelectedLocation,
  refine,
  updateSelectedLocation,
  deliveryToAddress,
  deepLinkParameters,
  getMarketplaceDeliveryLocations,
  setDeliveryTimeFormIsVisible,
  checkUnavailableProductForMarketplace,
  resetMarketplaceDeliveryLocations,
  confirmDeliveryDetails,
  setMarketplaceDeliverySelection,
  checkUnavailableProductForPickUp,
  setParentLocation,
  getChildLocations,
  appConfig,
  guestDeliveryFormInitialAddress,
  setGuestDeliveryAddressFormInitialValues,
  profileSettingsReducer,
  setPickUpTimeFormIsVisible,
  validateCartForLocation,
  resetCartErrorMessages,
  resetGuestSession,
  setIsParentStoreDeepLink,
  getMenu,
}) => {
  //useDeepLink();
  const [showConfirmButton, setShowConfirmButton] = useState(true);

  const cartItems = {
    products: cartReducer.products,
    combos: cartReducer.combos,
  };
  const {
    orderType,
    interOrderType,
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
    availableTimes,
    interSelectedDateTime,
    orderSettingModalIsVisible,
    unavailableProducts,
    isRequesting,
    toolTipIsHidden,
    selectedDateTime,
    isTimeNoLongerValid,
    specialHours,
    orderPacingData,
    selectedLocation,
    cartErrorMessage,
    marketplaceDeliveryLocations,
    isMarketplaceDeliveryLocationsRequest,
    deliveryTimeFormIsVisible,
    deliveryDetails,
    isUnavailableProductInCartRequest,
    parentLocation,
    childLocations,
    isDeepLink,
    isParentDeepLink,
  } = orderSettingReducer;

  const {
    pickedDropOffLocation,
    dropOffLocations,
    selectedDropOffLocation,
    getDropOffLocationsIsRequesting,
  } = dropOffLocationReducer;

  useEffect(() => {
    if (
      selectedLocation &&
      selectedLocation.is_order_ahead_enabled &&
      interOrderType === PICKUP
    )
      getBusinessSpecialHours(selectedLocation, interOrderType);

    if (
      selectedLocation &&
      selectedLocation.settings &&
      selectedLocation.deliveryBusiness &&
      selectedLocation.deliveryBusiness.is_order_ahead_enabled &&
      interOrderType === DELIVERY
    )
      getBusinessSpecialHours(selectedLocation, interOrderType);

    if (
      interDropOffDetails &&
      interDropOffDetails.is_order_ahead_enabled &&
      interDropOffDetails === DROPOFF
    )
      getBusinessSpecialHours(interDropOffDetails, interOrderType);
  }, [selectedLocation, interDropOffDetails]);

  useEffect(() => {
    const specialHoursModified = specialHours.filter(
      (day) => day.date === moment().format('YYYY-MM-DD')
    );

    if (
      specialHoursModified[0] &&
      !specialHoursModified[0].order_start_time &&
      !specialHoursModified[0].order_end_time
    ) {
      updateInterSelectedDateTime({
        radioValue: interSelectedDateTime.radioValue,
        dateTime: {
          date: {
            name: moment()
              .add(1, 'days')
              .format('ddd MMM DD'),
            value: moment()
              .add(1, 'days')
              .toString(),
          },
          time: {
            name: '',
            value: '',
          },
        },
      });
      if (selectedLocation)
        getTimeIntervalsDate(
          selectedLocation.id,
          moment()
            .add(1, 'days')
            .toString()
            .toString()
        );
    }
  }, [selectedLocation, specialHours]);

  useEffect(() => {
    if (selectedLocation && interOrderType === PICKUP)
      getTimeIntervalsDate(selectedLocation.id, new Date().toString());
    if (interDropOffDetails && interOrderType === DROPOFF)
      getTimeIntervalsDate(interDropOffDetails.id, new Date().toString());
    if (
      selectedLocation &&
      selectedLocation.deliveryBusiness &&
      interOrderType === DELIVERY
    )
      getTimeIntervalsDate(
        selectedLocation.deliveryBusiness.id,
        new Date().toString()
      );
  }, [selectedLocation, interDropOffDetails, interOrderType]);

  useEffect(() => {
    resetCartErrorMessages();
  }, []);
  useEffect(() => {
    let id = null;
    let type = null;
    if (interOrderType === PICKUP && interPickUpDetails) {
      type = 'pickup';
      id = interPickUpDetails.id;
    } else if (interOrderType === DELIVERY && interDeliveryDetails) {
      type = 'delivery';
      id = interDeliveryDetails.business_id;
    } else if (interOrderType === DROPOFF && interDropOffDetails) {
      type = 'drop_off';
      id = interDropOffDetails.id;
    }
    if (id && type) {
      localStorage.setItem('business_id', id);
      localStorage.setItem('order_type', type);
    }
  }, [
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
    interOrderType,
  ]);
  const handleConfirmPickupButton = (childLocation) => {
    if (!isAuthenticated) {
      emptyCart();
    } else {
      if (unavailableProducts?.length > 0) {
        const unavailableProductsModified = unavailableProducts.map(
          (product) => product.product_id
        );
        updateCartWithUnavailbleProducts(unavailableProducts);
        updateCartWithUnavailbleProducts(unavailableProductsModified);
      }
    }
    updateSelectedLocation(childLocation);
    updateInterPickUpDetails(childLocation, new Date().toString());
    confirmPickUpDetails(true);
    validateGlobalCart(null, null, selectedLocation.id);
    if (
      appConfigFile.isGlobalSearchEnabled &&
      interPickUpDetails &&
      (!interPickUpDetails.accepting_orders || !interPickUpDetails.open)
    ) {
      refine('');
    }
  };

  const handleConfirmDropOffButton = () => {
    if (!isAuthenticated) {
      emptyCart();
    } else {
      if (unavailableProducts.length) {
        const unavailableProductsModified = unavailableProducts.map(
          (product) => product.product_id
        );
        updateCartWithUnavailbleProducts(unavailableProductsModified);
      }
    }
    confirmDropOffDetails(true);
  };

  // useEffect(() => {
  //   if (
  //     interPickUpDetails &&
  //     interPickUpDetails.is_order_ahead_enabled &&
  //     interOrderType === PICKUP
  //   )
  //     getBusinessSpecialHours(interPickUpDetails, interOrderType);

  //   if (
  //     interDropOffDetails &&
  //     interDropOffDetails.is_order_ahead_enabled &&
  //     interDropOffDetails === DROPOFF
  //   )
  //     getBusinessSpecialHours(interDropOffDetails, interOrderType);
  // }, [interPickUpDetails, interDeliveryDetails, interDropOffDetails]);

  // useEffect(() => {
  //   const specialHoursModified = specialHours.filter(
  //     (day) => day.date === moment().format("YYYY-MM-DD")
  //   );

  //   if (
  //     specialHoursModified[0] &&
  //     !specialHoursModified[0].order_start_time &&
  //     !specialHoursModified[0].order_end_time
  //   ) {
  //     updateInterSelectedDateTime({
  //       radioValue: interSelectedDateTime.radioValue,
  //       dateTime: {
  //         date: {
  //           name: moment()
  //             .add(1, "days")
  //             .format("ddd MMM DD"),
  //           value: moment()
  //             .add(1, "days")
  //             .toString(),
  //         },
  //         time: {
  //           name: "",
  //           value: "",
  //         },
  //       },
  //     });
  //     if (interPickUpDetails)
  //       getTimeIntervalsDate(
  //         interPickUpDetails.id,
  //         moment()
  //           .add(1, "days")
  //           .toString()
  //           .toString()
  //       );
  //   }
  // }, [interPickUpDetails, specialHours]);

  // useEffect(() => {
  //   if (interPickUpDetails && interOrderType === PICKUP)
  //     getTimeIntervalsDate(interPickUpDetails.id, new Date().toString());
  //   if (interDropOffDetails && interOrderType === DROPOFF)
  //     getTimeIntervalsDate(interDropOffDetails.id, new Date().toString());
  // }, [interPickUpDetails, interDropOffDetails, interOrderType]);

  return (
    <>
      <Dialog
        open={orderSettingModalIsVisible}
        onClose={() => {
          updateOrderSettingModalIsVisible(false);
          updateInterPickUpDetails(interPickUpDetails);
          updateInterSelectedDateTime(selectedDateTime);
          if (orderType === DROPOFF) {
            restoreSelectedLocation();
          }
        }}
        classes={{ scrollPaper: classes.scrollPaper }}
        PaperProps={{ classes: { root: classes.paper } }}
        aria-labelledby='order-method'
        scroll='body'
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
      >
        <MarketplaceOrderSettingModal
          cartItems={cartItems}
          interOrderType={interOrderType}
          updateInterOrderType={updateInterOrderType}
          locations={locations}
          currentLocation={currentLocation}
          updateInterPickUpDetails={updateInterPickUpDetails}
          interPickUpDetails={interPickUpDetails}
          deliveryAddressesList={deliveryAddressesList}
          updateInterDeliveryDetails={updateInterDeliveryDetails}
          interDeliveryDetails={interDeliveryDetails}
          availableTimes={availableTimes}
          interSelectedDateTime={interSelectedDateTime}
          updateInterSelectedDateTime={updateInterSelectedDateTime}
          getTimeIntervalsDate={getTimeIntervalsDate}
          updateOrderSettingModalIsVisible={updateOrderSettingModalIsVisible}
          confirmPickUpDetails={confirmPickUpDetails}
          unavailableProducts={unavailableProducts}
          resetInterSelectedDateTime={resetInterSelectedDateTime}
          deliveryBusiness={
            interDeliveryDetails && interDeliveryDetails.deliveryBusiness
          }
          resetDateTimes={resetDateTimes}
          isRequesting={isRequesting}
          requestingGetLocations={requestingGetLocations}
          isTimeNoLongerValid={isTimeNoLongerValid}
          resetIsTimeNoLongerValid={resetIsTimeNoLongerValid}
          confirmMarketplaceDeliverySelection={
            confirmMarketplaceDeliverySelection
          }
          handleConfirmPickupButton={handleConfirmPickupButton}
          setDeliveryAddressesFormIsVisible={setDeliveryAddressesFormIsVisible}
          isAuthenticated={isAuthenticated}
          hideToolTip={hideToolTip}
          selectedDateTime={selectedDateTime}
          toolTipIsHidden={toolTipIsHidden}
          orderHistory={orderHistory}
          nearestLocation={nearestLocation}
          specialHours={specialHours}
          orderPacingData={orderPacingData}
          setDropOffLocationFormIsVisible={setDropOffLocationFormIsVisible}
          interDropOffDetails={interDropOffDetails}
          updateInterDropOffDetails={updateInterDropOffDetails}
          confirmDropOffDetails={confirmDropOffDetails}
          getFirstDropOffSelection={getFirstDropOffSelection}
          pickedDropOffLocation={pickedDropOffLocation}
          setIsEditDropOffLocation={setIsEditDropOffLocation}
          deleteDropOffLocation={deleteDropOffLocation}
          handleConfirmDropOffButton={handleConfirmDropOffButton}
          dropOffLocations={dropOffLocations}
          selectedDropOffLocation={selectedDropOffLocation}
          getDropOffLocationsIsRequesting={getDropOffLocationsIsRequesting}
          refine={refine}
          selectedLocation={selectedLocation}
          orderSettingModalIsVisible={orderSettingModalIsVisible}
          updateSelectedLocation={updateSelectedLocation}
          cartErrorMessage={cartErrorMessage}
          deliveryToAddress={deliveryToAddress}
          deepLinkParameters={deepLinkParameters}
          getMarketplaceDeliveryLocations={getMarketplaceDeliveryLocations}
          marketplaceDeliveryLocations={marketplaceDeliveryLocations}
          isMarketplaceDeliveryLocationsRequest={
            isMarketplaceDeliveryLocationsRequest
          }
          setDeliveryTimeFormIsVisible={setDeliveryTimeFormIsVisible}
          deliveryTimeFormIsVisible={deliveryTimeFormIsVisible}
          deliveryDetails={deliveryDetails}
          isUnavailableProductInCartRequest={isUnavailableProductInCartRequest}
          checkUnavailableProductForMarketplace={
            checkUnavailableProductForMarketplace
          }
          resetMarketplaceDeliveryLocations={resetMarketplaceDeliveryLocations}
          confirmDeliveryDetails={confirmDeliveryDetails}
          setMarketplaceDeliverySelection={setMarketplaceDeliverySelection}
          checkUnavailableProductForPickUp={checkUnavailableProductForPickUp}
          setParentLocation={setParentLocation}
          parentLocation={parentLocation}
          getChildLocations={getChildLocations}
          childLocations={childLocations}
          appConfig={appConfig}
          setGuestDeliveryAddressFormInitialValues={
            setGuestDeliveryAddressFormInitialValues
          }
          guestDeliveryFormInitialAddress={guestDeliveryFormInitialAddress}
          profileSettingsReducer={profileSettingsReducer}
          setPickUpTimeFormIsVisible={setPickUpTimeFormIsVisible}
          cartReducer={cartReducer}
          validateCartForLocation={validateCartForLocation}
          isDeepLink={isDeepLink}
          isParentDeepLink={isParentDeepLink}
          setIsParentStoreDeepLink={setIsParentStoreDeepLink}
          getMenu={getMenu}
          updateCartWithUnavailbleProducts={updateCartWithUnavailbleProducts}
          emptyCart={emptyCart}
          showConfirmButton={showConfirmButton}
          setShowConfirmButton={setShowConfirmButton}
          validateGlobalCart={validateGlobalCart}
        />
      </Dialog>

      <OrderingClosedContainer />
    </>
  );
};

const mapStateToProps = (state) => ({
  orderSettingReducer: state.orderSettingReducer,
  locations: state.locationsReducer.locations,
  deliveryAddressesList: state.deliveryAddressesReducer.deliveryAddressesList,
  dropOffLocationReducer: state.dropOffLocationReducer,
  requestingGetLocations: state.locationsReducer.requestingGetLocations,
  isAuthenticated: state.authReducer.isAuthenticated,
  currentLocation: state.locationsReducer.currentLocation,
  orderHistory: state.myTransactionsReducer.myTransactions,
  cartReducer: state.cartReducer,
  orderingClosedInAllLocations:
    state.locationsReducer.orderingClosedInAllLocations,
  deepLinkParameters: state.deepLinkReducer.parameters,
  deliveryToAddress: state.deliveryAddressesReducer.deliveryToAddress,
  appConfig: state.authReducer.appConfig,
  guestDeliveryFormInitialAddress:
    state.deliveryAddressesReducer.guestDeliveryFormInitialAddress,
  profileSettingsReducer: state.profileSettingsReducer,
});

export default withStyles(styles)(
  connect(mapStateToProps, {
    ...actions,
    setDeliveryAddressesFormIsVisible,
    validateCart,
    validateGlobalCart,
    updateCartWithUnavailbleProducts,
    emptyCart,
    setIsEditDropOffLocation,
    deleteDropOffLocation,
    setDropOffLocationFormIsVisible,
    getFirstDropOffSelection,
    restoreSelectedLocation,
    setGuestDeliveryAddressFormInitialValues,
    validateCartForLocation,
    resetCartErrorMessages,
    resetGuestSession,
    getMenu,
  })(
    appConfigFile.isGlobalSearchEnabled
      ? connectSearchBox(MarketplaceOrderSettingModalContainer)
      : MarketplaceOrderSettingModalContainer
  )
);
